var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.92841 1C5.75481 1 5.61409 1.14138 5.61409 1.31579V2.38813C5.21374 2.56868 4.84117 2.80029 4.50458 3.07473L3.54315 2.51705C3.39281 2.42985 3.20058 2.4816 3.11378 2.63264L1.54216 5.36747C1.45537 5.51851 1.50688 5.71164 1.65721 5.79885L2.67843 6.3912C2.65457 6.59079 2.64229 6.79397 2.64229 7.00002C2.64229 7.20612 2.65458 7.40933 2.67844 7.60896L1.65728 8.20128C1.50694 8.28849 1.45543 8.48162 1.54223 8.63266L3.11384 11.3675C3.20064 11.5185 3.39288 11.5703 3.54322 11.4831L4.50467 10.9254C4.84123 11.1998 5.21378 11.4314 5.61409 11.6119V12.6843C5.61409 12.8587 5.75481 13 5.92841 13H9.07164C9.24523 13 9.38596 12.8587 9.38596 12.6843V11.7515C9.85852 11.5793 10.2981 11.338 10.6926 11.0398L11.4568 11.4831C11.6072 11.5703 11.7994 11.5185 11.8862 11.3675L13.4578 8.63266C13.5446 8.48162 13.4931 8.28849 13.3428 8.20128L12.639 7.79309C12.6796 7.53472 12.7006 7.26984 12.7006 7.00002C12.7006 6.73025 12.6796 6.46541 12.639 6.20707L13.3428 5.79885C13.4932 5.71164 13.5447 5.51851 13.4579 5.36747L11.8863 2.63264C11.7995 2.4816 11.6072 2.42985 11.4569 2.51705L10.6927 2.96034C10.2982 2.66206 9.85856 2.42075 9.38596 2.24859V1.31579C9.38596 1.14138 9.24523 1 9.07164 1H5.92841Z",
    stroke: "#444444",
    strokeWidth: 1.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.50131,
    cy: 6.99984,
    r: 1.83334,
    stroke: "#444444",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSetting);
export default __webpack_public_path__ + "static/media/icon_setting.87484911ac03170576e082468d55ec32.svg";
export { ForwardRef as ReactComponent };